import React, { useContext, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { t } from "i18next";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import { Button } from "../design";

const WorkspaceInviationModal = ({
  isOpen,
  onClose,
  inviteData,
  setTempWorkspaceData,
  setOpenWelcomeModal,
}) => {
  const { _t } = useTranslator();
  const { acceptWorkspaceInvite, declineWorkspaceInvite } =
    useContext(LandLordContext);
  const { loadUser } = useContext(AuthContext);

  const [buttonDisable, setButtonDisable] = useState(false);

  const handleAcceptInvite = () => {
    setButtonDisable(true);
    acceptWorkspaceInvite({ workspaceId: inviteData?.workspaceId?._id })
      .then((res) => {
        setTempWorkspaceData({
          name: inviteData?.workspaceId?.name,
        });
        loadUser("landlord");
        setOpenWelcomeModal(true);
        onClose();
      })
      .catch((err) => {
        toast.error(_t("errorWhileAcceptingInvite"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };

  const handleDeclineInvite = () => {
    setButtonDisable(true);
    declineWorkspaceInvite({ workspaceId: inviteData?.workspaceId?._id })
      .then((res) => {
        toast.success(_t("workspaceInviteDeclined"));
        loadUser("landlord");
        onClose();
      })
      .catch((err) => {
        toast.error(_t("errorWhileDecliningWorkspaceInvite"));
      })
      .finally(() => {
        setButtonDisable(false);
      });
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      className="newmodalui max-w-lg d-flex justify-content-center align-items-center tailwind-base-modal wrapper-modal"
    >
      <Modal.Header className="justify-content-start" closeButton>
        <Modal.Title>{_t("workspaceInvitation")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="w-100 text-left">
        <div className="workspace-invitation-modal-info">
          <p>{_t("youHaveBeenInvitedToCollabrateInThisWorkspaceBy")}</p>{" "}
          <span>
            {inviteData?.workspaceId?.created_by?.fname_companyName ?? ""}{" "}
            {inviteData?.workspaceId?.created_by?.lname ?? ""}
          </span>
          <p>
            {_t("yourRoleWillBe")} <span>{inviteData?.role ?? ""}</span>
          </p>
          <p className="mt-2">
            {_t("byAcceptingThisWorkspaceWillBeAddedToYourList")}.
          </p>
        </div>
      </Modal.Body>
      <div className="inviteButtonWrapper">
        <Button
          variant="secondary"
          size="lg"
          type="button"
          onClick={handleDeclineInvite}
          disabled={buttonDisable}
        >
          {_t("decline")}
        </Button>
        <Button
          variant="primary"
          size="lg"
          type="button"
          onClick={handleAcceptInvite}
          disabled={buttonDisable}
        >
          {_t("acceptInvitation")}
        </Button>
      </div>
    </Modal>
  );
};

export default WorkspaceInviationModal;
